import { useEffect } from "react";
import api from "../api";
import { FirebaseMessaging } from "@capacitor-firebase/messaging";
import { Capacitor } from "@capacitor/core";

export default function useNativePush(jwt?: string) {
  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return;
    if (!jwt) return;

    let cancelled = false;
    let tokenListener: { remove: () => Promise<void> } | undefined;

    const syncToken = async (token: string) => {
      if (!token || cancelled) return;

      const response = await api.post(
        "/users/push-token",
        { token },
        {
          headers: {
            Authorization: `Bearer ${jwt}`,
          },
        }
      );

      if (cancelled) return;

      console.log("[Push] backend response:", response?.status);
      console.log(
        "✅ Native FCM token registered:",
        `${token.slice(0, 12)}...`
      );
    };

    const run = async () => {
      try {
        let permission = await FirebaseMessaging.checkPermissions();

        if (permission.receive !== "granted") {
          console.log("[Push] requesting permission...");

          permission =
            await FirebaseMessaging.requestPermissions();
        }

        if (
          permission.receive !== "granted" ||
          cancelled
        ) {
          return;
        }

        // Keep the backend updated if Firebase rotates the FCM token.
        const listener = await FirebaseMessaging.addListener(
          "tokenReceived",
          async ({ token }) => {
            try {
              await syncToken(token);
            } catch (error: any) {
              console.error(
                "[Push] token refresh sync failed",
                error?.message || error,
                error
              );
            }
          }
        );

        if (cancelled) {
          await listener.remove();
          return;
        }

        tokenListener = listener;

        // Register/retrieve the current token immediately.
        const { token } = await FirebaseMessaging.getToken();

        await syncToken(token);
      } catch (error: any) {
        if (!cancelled) {
          console.error(
            "[Push] native push setup failed",
            error?.message || error,
            error
          );
        }
      }
    };

    run();

    return () => {
      cancelled = true;
      tokenListener?.remove();
    };
  }, [jwt]);
}